import React from 'react';
import TransactionDetails from '../Components/TransactionDetails.js';

function Show() {
    return (
        <div>
            <TransactionDetails />
        </div>
    );
};

export default Show;